const Form070TC = {
    stepName: {
        Statement: "重要事項",
        schoolInfo: "學校資料",
        SectionA: "甲部",
        SectionB: "乙部",
        certification: "丙部\n認證",
        Confirmation: "確認",
    },
    label: {
        reasonOption: {
            a: "有薪病假／產假／肺病特別假期",
            b: "有薪進修假期",
            c: "有薪進修假期（學校如有一位或多於一位教師修讀指定的專業進修課程而為期達30個連續曆日或以上），請註明課程編號",
            d: "給予教師有薪假期，以便出任陪審員或證人",
            e: "有薪侍產假",
            f: "其他有薪假期",
            x: "無薪病假／產假／肺病特別假期",
            y: "其他無薪假期",
        },
        surplusOption: {
            yes: "有",
            no: "沒有",
        },
        formTypeOption: {
            N: "新表格",
            R: "修订表格",
        },
        changePreClaimOption: {
            unDelete: "不更改先前聲明",
            delete: "刪除先前聲明",
            change: "更改先前聲明",
        },

        partBi: "乙部 有關以月薪聘任的臨時教師，請遞交教育局網頁內的聘任表格（",
        partBii: "http://www.edb.gov.hk",
        partBiii: "→ 學校行政及管理 → 一般行政 → 有關學校教職員 → 聘任事宜）",
        partC: "丙部 認證",
        // note: "重要事項",
        statement: "個人資料收集聲明",
        surplusTeachers: "過剩教師：",
        surplusNo: "過剩教師數量",
        termsConditions: "本人已閱讀「個人資料收集聲明」及完全明白其內容。",
        iamStatement: "本人明白需透過「智方便+」帳戶以辧理申請。",
        headerOne: "學校資料",
        schoolName: "學校名稱",
        schoolCode: "學校代碼",
        Month: "月份",
        Year: "年份",
        headerTwoA:
            "甲部 發還因教師休假30至89曆日或教師連續放取3天或以上的侍產假",
        headerTwoB:
            "或於調整班級數目後不獲發放整合代課教師津貼中的全年經常性現金津貼的學校，其休假連續3日或以上的教師數目超逾過剩教師數目",
        headerTwoC:
            "而聘任合資格代課教師所支付的薪金及強積金計劃僱主供款（有關必須向強積金供款的代課教師，如申領津貼期少於60天，請提供強積金供款的資料證明）",
        headerTwoNote1:
            "以薪金津貼聘請的教師如放取連續3天或以上的侍產假，學校便可以實報實銷形式申請發還支付代課教師的開支。有關詳情，請參閱教育局通告第16/2015號。",
        headerTwoNote2: "有關詳情請參閱本指引的附件IV。",
        formType: "新/修訂表格",
        changePreclaim: "不更改先前聲明／刪除先前聲明／更改先前聲明",
        preclaimNum: "請註明前次申領的申請編號",
        previousDate: "前次申領表格日期：",
        previousFormFile: "前次申領表格副本：",
        applicationNum: "申請編號",

        headerThree: "休假教師",
        leaveTeacherName: "姓名",
        leaveTeacherSRN: "職員參考編號",
        leaveTeacherReason: "缺勤原因",
        leaveTeacherPost: "職位",
        leaveDatelabel: "休假日期",
        leaveStartTime: "由",
        leaveEndTime: "至",
        supplyTeacherName: "代課教師姓名",
        supplyDatelabel: "代課日期",
        supplyStartTime: "由",
        supplyEndTime: "至",
        workDaysNo: "工作日數",
        DailyRate: "日薪率",
        salaryAmount: "薪金",
        trusteeReceipt:
            "已付予代課教師及／或強積金計劃的受託人有關薪酬的收據證明：",
        MPFSubsidy: "強積金供款津貼",
        contractDatelabel: "合約期",
        contractStartTime: "由",
        contractEndTime: "至",
        MPFfile: "強積金供款的資料證明：",
        totalSalaryAmount: "總額（薪金總額）",
        totalMPFSubsidy: "總額（強積金供款津貼）",
        specify: "（ 請說明原因 ）",
        otherReason: "其他有薪假期的原因",
        validReason: "原因",
        courseId: "有薪進修假期的課程編號",
        confirm: "確認",
        tooltip1:
            "以薪金津貼聘請的教師如放取連續3天或以上的侍產假，學校便可以實報實銷形式申請發還支付代課教師的開支。有關詳情，請參閱教育局通告第16／2015號。",
        tooltip2:
            "學校必須按照教育局通告第1／2006號以及第16／2015號(侍產假適用)的規定批假。",
        partCLabel: "本校會把多付的津貼退還政府。",

        signDate: "日期",
        signContactPerson: "聯絡人",
        signTelNo: "電話號碼",
        signSsdo: "高級學校發展主任",
    },
    noteList: {
        noteOne: "請填寫休假教師的職員參考編號。",
        noteTwo: "請以下列字母標明缺勤原因─",
        noteTwoB:
            "學校必須按照教育局通告第1／2006號以及第16／2015號（侍產假適用）的規定批假。",
        noteThree:
            "請注意，學校申請發還的津貼，是用以聘請合資格的日薪代課教師，以代替放取核准假期的教學人員。如有關教學人員在休假期間的教學和其他職務是由校內其他人員代為處理，學校不能就此代課安排申請發還津貼。",
        noteFour:
            "工作日數不應包括星期日、星期六（短周）、公眾假期、由學校自行訂定的假期或教師毋須執行職務的任何周日。",
        noteFive:
            "有關資助學校代課教師當時適用的日薪率，請參閱相關的教育局通函。",
        noteSix:
            "如代課期少於60個曆日，但代課教師須向強積金供款，請提供證明資料。",
        noteSeven:
            "有關以月薪聘任的臨時教師，請遞交教育局網頁內的聘任表格（http://www.edb.gov.hk → 學校行政及管理 → 一般行政 → 有關學校教職員 → 聘任事宜）",
    },
    statementList: [
        {
            text: "本人證實*–",
        },
        {
            text: "有關薪酬已付予代課教師及／或強積金計劃的受託人。隨函付上有關收據，以供記錄存檔;",
        },
        {
            text: "上述申請不在整合代課教師津貼的涵蓋範圍；",
        },
        {
            text: "本申請符合有關整合代課教師津貼申請所訂明的條件；",
        },
        {
            text: {
                t1: "本校",
                t2: "過剩教師",
                t3: "而在聘請任何代課教師前，過剩教師數目已經抵銷；",
                t4: "並",
                t5: "名",
            },
        },
        {
            text: "本校沒有就上述假期／空缺向政府提出其他津貼的申請，例如以現金津貼取代額外英語教師職位及把小數位教師職位轉為小數位職位現金津貼；",
        },
        {
            text: "如上述編制內的教師放取侍產假，學校已按照相關規定批准；以及",
        },
        {
            text: "學校已查核代課教師的教師註冊文件，以及徵得他們的同意，向教育局申請發放其教師註冊資料。",
        },
    ],

    statemenStep: [
        {
            step: "（i）",
        },
        {
            step: "（ii）",
        },
        {
            step: "（iii）",
        },
        {
            step: "（iv）",
        },
        {
            step: "（v）",
        },
        {
            step: "（vi）",
        },
        {
            step: "（vii）",
        },
    ],

    errorMsg: {
        numLimit: "請輸入{{limit}}",
        dayslimit1:
            "學校可以實報實銷形式申請發還因教師休假30至89曆日而聘任代課教師所支付的薪金，以下情況除外﹕",
        dayslimit2: "教師連續放取3天或以上的侍產假；及／或",
        dayslimit3:
            "於調整班級數目後不獲發放整合代課教師津貼中的全年經常性現金津貼的學校，其休假連續3日或以上的教師數目超逾過剩教師數目。",
        // leaveDate: "截止日期不得晚於該科目學年的8月31日",
        supplyDate: "代課開始日期應該在休假期間範圍內",
        supplyDateEnd: "代課结束日期應該在休假期間範圍內",
        contractDate: "截止日期不得晚於該科目學年的8月31日",
        date: {
            year: "請輸入有效年份",
        },
        number: {
            min: "此項最小值必須大於0",
        },
        paternityLeave: "帶薪陪產，休假期限>=3個日曆日",
        workDays: "工作日數不能大於代課天數",
        E0001: "請輸入一個有效的聯絡人",
    },
};
export default Form070TC;
